import React, { ReactNode } from 'react'
import { useRouter } from 'next/router'

// Components
import Image from 'next/image'

// Libs
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Styles
import classnames from 'classnames/bind'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ApplyRoleEntryCardProps {
  title: ReactNode
  description: ReactNode
  image: string
  icon: ReactNode
  buttonText: string
  buttonLink: string
}

const ApplyRoleEntryCard = ({ title, description, image, icon, buttonText, buttonLink }: ApplyRoleEntryCardProps) => {
  const router = useRouter()

  const handleStartClick = () => {
    handleRoutePushWithQuery({ router, pathname: buttonLink })
  }

  return (
    <div className={cx('apply-role-entry-card')}>
      {/* Background with image and overlay */}
      <div className={cx('apply-role-entry-card__background')}>
        <Image
          src={image}
          alt='Apply merchant background'
          fill
          className={cx('apply-role-entry-card__background-image')}
          style={{ objectFit: 'cover' }}
        />
        <div className={cx('apply-role-entry-card__background-overlay')} />
      </div>

      {/* Content */}
      <div className={cx('apply-role-entry-card__content')}>
        <div className={cx('apply-role-entry-card__header')}>
          {/* Icon */}
          <div className={cx('apply-role-entry-card__icon-wrapper')}>{icon}</div>

          {/* Title */}
          <p className={cx('apply-role-entry-card__title')}>{title}</p>
        </div>

        {/* Description */}
        <div className={cx('apply-role-entry-card__description')}>{description}</div>
      </div>

      {/* Button */}
      <button className={cx('apply-role-entry-card__button')} onClick={handleStartClick}>
        <p className={cx('apply-role-entry-card__button-text')}>{buttonText}</p>
      </button>
    </div>
  )
}

export default ApplyRoleEntryCard
